// Shared breakpoints for the sidebar's responsive behavior.
export const MOBILE_MAX_WIDTH = 767;
// Common tablet upper bound (iPad portrait/landscape and similar).
export const TABLET_MAX_WIDTH = 1024;
